import avalancheFujiTokens from '../constants/avalanche_fuji_tokens';
import mainnetTokens from '../constants/mainnet_tokens';
import avalancheTokens from '../constants/avalanche_tokens';
import bscTestnetTokens from '../constants/bnb_testnet_tokens';
import bscTokens from '../constants/bsc_tokens';
import baseTokens from '../constants/base_tokens';
import solanaTokens from '../constants/solana_tokens';

export const getTokens = (network) => {
  if (network == 'avalanche-fuji' || network == '43113') {
     return avalancheFujiTokens;
  }  if (network == 'mainnet'  || network == '1') {
    return mainnetTokens;
  }  if (network == 'avalanche'  || network == '43114') {
    return avalancheTokens;
  }  if (network == 'bsc'  || network == '56') {
    return bscTokens;
  }  if (network.toLowerCase() == 'bsc-testnet'  || network == '97') {
    return bscTestnetTokens;
  } if (network.toLowerCase() == 'base'  || network == '8453') {
    return baseTokens;
  }  if (network.toLowerCase() == 'solana'  || network == 'solana') {
    return solanaTokens;
  }else {
    return [];
  }
};
